import MapOutlined from "@mui/icons-material/MapOutlined";
import TableRowsOutlined from "@mui/icons-material/TableRowsOutlined";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { TextInput } from "qubCommon/Inputs";
import { useState } from "react";
import { useNavigate } from "react-router";
import ApartmentsMapView from "./Apartments/ApartmentsMapView";

const TRANSFER_DESTINATION_COLUMNS = new Set([
  "ApartmentCapacity",
  "ApartmentAvailability",
  "ApartmentPendingRequests",
]);

const ApartmentsExplorer = () => {
  const [isMapView, setIsMapView] = useState(false);
  const [contextMenuApplicationId, setContextMenuApplicationId] =
    useState(null);
  const [contextMenuDestinationMhdId, setContextMenuDestinationMhdId] =
    useState(null);
  const navigate = useNavigate();

  const handleOpenApplication = (item, openInNewTab, columnBinding) => {
    const destinationMhdId = item?.DestinationMhdId;
    const opensTransfers =
      TRANSFER_DESTINATION_COLUMNS.has(columnBinding) && destinationMhdId;
    let targetUrl = item?.ApplicationId
      ? item?.ApartmentId
        ? `/govnr/mhds/${item.ApplicationId}/apartments/${item.ApartmentId}`
        : `/govnr/mhds/${item.ApplicationId}`
      : null;

    if (opensTransfers) {
      targetUrl = `/govnr/transfers?destinationId=${encodeURIComponent(
        destinationMhdId
      )}`;
    }

    if (!targetUrl) return;

    if (openInNewTab) {
      const newWindow = window.open(targetUrl, "_blank");
      newWindow?.focus();
      return;
    }

    navigate(targetUrl);
  };

  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "MhdApartments-Expl",
    hideAddNew: true,
  });

  const { explParams, contextMenu, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "MhdApartments-Expl",
    xlsxName: "Διαμερίσματα ΜΗΔ",
    navUrl: "/application/{:id}",
    status,
    onSelect: handleOpenApplication,
    onPopup: (item) => {
      setContextMenuApplicationId(item?.ApplicationId);
      setContextMenuDestinationMhdId(item?.DestinationMhdId);
    },
  });
  const contextMenuExtraNavs = [
    contextMenuApplicationId
      ? {
          label: "Άνοιγμα ΜΗΔ",
          path: `/govnr/mhds/${contextMenuApplicationId}`,
        }
      : null,
    contextMenuDestinationMhdId
      ? {
          label: "Άνοιγμα Μετακινήσεων Ωφελ.",
          path: `/govnr/transfers?destinationId=${encodeURIComponent(
            contextMenuDestinationMhdId
          )}`,
        }
      : null,
  ].filter(Boolean);

  return (
    <>
      <Can I="View" a="MHD_Apartments">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          <ExplorerGrid
            explParams={explParams}
            title="MhdApartments"
            breadcrumbs={[
              { name: "apartments", path: "govnr/apartments-explorer" },
            ]}
            hideAscendingRowNumber
            autoRowHeights
            buttons={
              <Box boxShadow={2} sx={{ borderRadius: 50 }}>
                <Tooltip
                  title={isMapView ? "Προβολή πίνακα" : "Προβολή χάρτη"}
                >
                  <IconButton
                    aria-label={
                      isMapView ? "Προβολή πίνακα" : "Προβολή χάρτη"
                    }
                    aria-pressed={isMapView}
                    onClick={() => setIsMapView((currentView) => !currentView)}
                  >
                    {isMapView ? <TableRowsOutlined /> : <MapOutlined />}
                  </IconButton>
                </Tooltip>
              </Box>
            }
            alternativeView={isMapView ? <ApartmentsMapView /> : null}
            {...explorerRest}
            {...toolbarRest}
            navUrl=""
            extraNavs={contextMenuExtraNavs}
            contextMenu={{
              ...contextMenu,
            }}
          >
            <Grid item xs={12} md={6} lg={4}>
              <TextInput
                id="Search"
                name="searchFieldValue"
                label={"Αναζήτηση"}
                placeholder={"Αναζήτηση"}
                defaultValue={critParams?.searchFieldValue ?? ""}
              />
            </Grid>
          </ExplorerGrid>
        </div>
      </Can>
      <Can not I="View" a="MHD_Apartments">
        <PageNotFound />
      </Can>
    </>
  );
};
export default ApartmentsExplorer;
